module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/placeholder.0510b40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/placeholder.jpg
// module id = /OJd
// module chunks = 0